import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { createTranslateLoader } from '../core/factories/translate.factory';
import { HttpClient } from '@angular/common/http';
import { MaskCardNumberPipe } from '../core/pipes/mask-card-number.pipe';
import { TrackClickDirective } from '../core/directives/track-click.directive';
import { MaskPinPipe } from '../core/pipes/mask-pin.pipe';
import { NumberTrackerComponent } from './components/number-tracker/number-tracker.component';
import { CharInStrPipe } from './pipes/char-in-str.pipe';
import { TrimInputDirective } from '../core/directives/trim-input.directive';
import { TrimRefCodePipe } from '../core/pipes/trim-ref-code.pipe';
import { NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [MaskCardNumberPipe, TrackClickDirective, MaskPinPipe, NumberTrackerComponent,
    CharInStrPipe, TrimInputDirective, TrimRefCodePipe],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    NgxMaskDirective, NgxMaskPipe
  ],
  providers: [provideEnvironmentNgxMask()],
  exports: [TranslateModule, MaskCardNumberPipe, TrackClickDirective, MaskPinPipe,
    NumberTrackerComponent, CharInStrPipe, TrimInputDirective, TrimRefCodePipe, NgxMaskDirective, NgxMaskPipe],
})
export class SharedModule { }
